import { useState, useEffect } from 'react'
import api from '../api'

// Карточка «Разбор последнего звонка» — ОДНА на оба кабинета (решение Антона 10.08
// «код не плоди»): у звонильщицы живёт в правой колонке, у сопроводителя — широкой
// плашкой над рабочей областью (проп wide). Сама поллит /my/latest и появляется,
// когда есть разбор свежего звонка; Modal — существующий CallDetailModal.
export default function CallReviewCard({ wide, Modal }) {
  const [data, setData] = useState(null)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    let alive = true
    const load = () => api.get('/api/call-analysis/my/latest')
      .then(r => { if (alive) setData(r.data && r.data.found ? r.data : null) })
      .catch(() => {})
    load()
    const t = setInterval(load, 120 * 1000)
    return () => { alive = false; clearInterval(t) }
  }, [])

  if (!data) return null

  const d = new Date(data.at)
  const today = new Date().toDateString() === d.toDateString()
  const when = (today ? 'Сегодня ' : d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' }) + ' ') +
    d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
  const mins = data.durationSec >= 60 ? Math.round(data.durationSec / 60) + ' мин' : data.durationSec + ' сек'
  const phone = data.clientPhone ? '+7 ' + String(data.clientPhone).replace(/\D/g, '').slice(-10).replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2-$3-$4') : null
  const bad = data.outcome && /отказ|не дозвон|не взял|бросил/i.test(data.outcome)

  return (
    <div className={'bg-white rounded-2xl border border-slate-200 p-4 ' + (wide ? 'mb-3' : '')}>
      <div className="flex items-center justify-between gap-2 mb-1">
        <div className="text-[13px] font-bold text-slate-800">Разбор последнего звонка</div>
        {data.outcome && (
          <span className="text-[11px] font-bold px-2 py-0.5 rounded-full shrink-0"
            style={bad ? { background: '#FFF7ED', color: '#B45309' } : { background: '#ECFDF5', color: '#047857' }}>
            {data.outcome}
          </span>
        )}
      </div>
      <div className="text-[11.5px] text-slate-400 mb-2.5">
        {when} · {mins}{phone ? ' · ' + phone : ''}{data.clientName ? ' (' + data.clientName + ')' : ''}
      </div>
      <div className={wide ? 'flex gap-6' : ''}>
        {data.good && (
          <div className={wide ? 'flex-1 min-w-0' : 'mb-2'}>
            <div className="text-[11px] font-bold mb-0.5" style={{ color: '#047857' }}>Что хорошо</div>
            <div className="text-[12px] text-slate-600 leading-snug">{data.good}</div>
          </div>
        )}
        {data.improve && (
          <div className={wide ? 'flex-1 min-w-0' : 'mb-2.5'}>
            <div className="text-[11px] font-bold mb-0.5" style={{ color: '#B45309' }}>Что поправить</div>
            <div className="text-[12px] text-slate-600 leading-snug">{data.improve}</div>
          </div>
        )}
      </div>
      <button onClick={() => setOpen(true)}
        className={'rounded-lg border border-sky-200 bg-sky-50 text-sky-800 text-[12px] font-bold py-1.5 hover:bg-sky-100 ' + (wide ? 'px-4 mt-2' : 'w-full mt-0.5')}>
        Смотреть разбор целиком
      </button>
      {!wide && (
        <div className="text-[10.5px] text-slate-400 text-center mt-1.5">Разбор появляется сам через пару минут после звонка</div>
      )}
      {open && Modal ? <Modal call={data.call} onClose={() => setOpen(false)} /> : null}
    </div>
  )
}
